import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

const styles = () => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    color: '#5F6368',
  },

  guide: {
    boxShadow: '0px 0px 10px #00000026',
    border: '1px solid #FFFFFF',
    borderRadius: '5px',
    padding: '30px',
    marginBottom: '30px',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 15px #0000001A',
      border: '1px solid #1765FF',
    }
  },

  box: {
    boxShadow: '0px 0px 10px #00000026',
    borderRadius: '5px',
    padding: '40px',
    marginBottom: '30px',
  },

  linkGroup: {
    display: 'flex',
    fontSize: 15,
    paddingTop: '10px',
    justifyContent: 'space-between',
  },

  templateLink: {
    border: '1px solid #195AFF',
    borderRadius: '3px',
    width: '360px',
    textAlign: 'center',
    padding: '15px 0',
    letterSpacing: '0.3px',
    textIndent: '0.3px',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 15px #00000026',
      border: '1px solid #195AFF',
    }
  },

  heading: {
    fontWeight: 'bold',
    marginBottom: '10px',
    fontSize: 17,
    textAlign: 'center',
    letterSpacing: '0.34px',
    textIndent: '0.34px',
  },

  lead: {
    fontSize: 13,
    letterSpacing: '0.25px',
    textIndent: '0.25px',
    whiteSpace: 'break-spaces',
    lineHeight: '1.5em',
  },

  flex: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  faqContent: {
    textAlign: 'center',
    paddingTop: 30,
  },
});

class FaqIndex extends React.Component {
  renderFaq = () => {
    const { classes } = this.props;
    return (
      <div className={classes.faqContent}>
        <div className={classes.lead}>
          レター送付・Salesforce連携以外のことでお困りの場合はこちらをご覧ください。
        </div>
        <div className={classes.guide} style={{ margin: '25px 0 60px 0' }} onClick={() => this.props.goTo('/how-to/faq')}>
          <div className={classes.heading} style={{ marginBottom: 5 }}>よくある質問</div>
          <div className={classes.lead}>
            レター注文後の流れやKeyman Letterの使い方などでよくある質問をまとめています。
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { classes } = this.props;
    if (this.props.howToType === 'レター送付ガイド') {
      return (
        <div className={classes.root}>
          <div className={classes.box}>
            <div className={classes.heading}>レターのテンプレートダウンロード</div>
            <div className={classes.linkGroup}>
              <div className={classes.templateLink} onClick={() => this.props.handleDownloadFile(false)}>
                テンプレート「ご面会依頼の件」①
              </div>
              <div className={classes.templateLink} onClick={() => this.props.handleDownloadFile(true)}>
                {"テンプレート「ご面会依頼の件」②"}
              </div>
            </div>
          </div>
          <div className={classes.guide} onClick={() => this.props.goTo('/how-to/send-letter/guide')}>
            <div className={classes.heading} style={{ marginBottom: 5 }}>Keyman Letter入稿ガイド</div>
            <div className={classes.lead} style={{ textAlign: 'center' }}>
              レターデータの入稿形式や、word上での編集で気をつけることなどをご確認いただけます。
            </div>
          </div>
          <div className={classes.flex}>
            <div className={classes.guide} style={{ padding: '40px 0', width: 395 }} onClick={() => this.props.goTo('/how-to/send-letter/tips')}>
              <div className={classes.heading}>レター書き方Tips</div>
              <div className={classes.lead} style={{ width: 330, margin: 'auto' }}>
                時候の挨拶、文面の書き方や効果的な構成など、レターの書き方に関する豆知識をまとめてご紹介します。
              </div>
            </div>
            <div className={classes.guide} style={{ padding: '40px 0', width: 395 }} onClick={() => this.props.goTo('/how-to/send-letter/qrcode')}>
              <div className={classes.heading}>QRコードの効果的な活用方法</div>
              <div className={classes.lead} style={{ width: 330, margin: 'auto' }}>
                会社HPから日程調整URLまで、QRコードのリンク先の事例をご紹介します。QRコードの設定手順についても記載しています。
              </div>
            </div>
          </div>
          {this.renderFaq()}
        </div>
      )
    } else if (this.props.howToType === 'Salesforce連携') {
      return (
        <div className={classes.root}>
          <div className={classes.guide} onClick={() => this.props.goTo('/how-to/salesforce/connect-account')}>
            <div className={classes.heading} style={{ marginBottom: 5 }}>アカウント連携方法</div>
            <div className={classes.lead} style={{ textAlign: 'center' }}>
              {"Keyman LetterアカウントをSalesforceアカウントに連携するための方法です。\nKeyman Letter及びSalesforceの管理画面より、連携の手続きを進めることができます。"}
            </div>
          </div>
          <div className={classes.guide} onClick={() => this.props.goTo('/how-to/salesforce/operation')}>
            <div className={classes.heading} style={{ marginBottom: 5 }}>レター送付のSalesforceの運用のイメージ</div>
            <div className={classes.lead} style={{ textAlign: 'center' }}>
              {"Keyman LetterアカウントをSalesforceアカウントに連携したあとの運用についての解説です。\nレター注文後、どのようにSalesforceにデータが連携されるかを確認いただけます。"}
            </div>
          </div>
          <div className={classes.guide} onClick={() => this.props.goTo('/how-to/salesforce/duplication')}>
            <div className={classes.heading} style={{ marginBottom: 5 }}>Salesforceとのデータの重複について</div>
            <div className={classes.lead} style={{ textAlign: 'center' }}>
              {"Keyman Letterで同期したデータとSalesforce上のデータとの重複についての解説です。"}
            </div>
          </div>
          {this.renderFaq()}
        </div>
      )
    } else {
      return (
        <div className={classes.root}>
          <div className={classes.heading} style={{ fontSize: 28, fontWeight: 'normal', letterSpacing: '0.55px', textIndent: '0.55px', marginBottom: 45 }}>
            どんなことでお困りですか？
          </div>
          <div className={classes.flex}>
            <div className={classes.guide} style={{ padding: '40px 0', width: 395 }} onClick={() => this.props.goTo('/how-to/send-letter')}>
              <div className={classes.heading}>レター送付について</div>
              <div className={classes.lead} style={{ width: 330, margin: 'auto' }}>
                レターテンプレートのダウンロードや入稿ガイド、レターの書き方など、レター送付に関することをご紹介します。
              </div>
            </div>
            <div className={classes.guide} style={{ padding: '40px 0', width: 395 }} onClick={() => this.props.goTo('/how-to/salesforce')}>
              <div className={classes.heading}>Salesforce連携について</div>
              <div className={classes.lead} style={{ width: 330, margin: 'auto' }}>
                Keyman LetterとSalesforceを連携する手順や、連携後の運用イメージについてご紹介します。
              </div>
            </div>
          </div>
          {this.renderFaq()}
        </div>
      )
    }
  }
}

FaqIndex.propTypes = {
  classes: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
  handleDownloadFile: PropTypes.func.isRequired,
  howToType: PropTypes.string,
};

export default withStyles(styles)(FaqIndex);



// WEBPACK FOOTER //
// ./src/components/Faq/FaqIndex.jsx